/*
 * Layout Name: About Gallery
 * Desc:
 */
// libs
import React from "react"
import { Image } from "react-datocms"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
// assets
import * as styles from "./AboutGalleryS.module.scss"

// components

const AboutGallery = (props) => {
  const { gallery } = props

  const sliderSettings = {
    // centerMode: true,
    slidesToShow: 1.2,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.1,
        },
      },
    ],
  }

  const slides =
    gallery && gallery.length
      ? gallery.map((slide) => (
          <div key={slide.id} className={styles.slide}>
            <Image lazyLoad={false} data={slide.photo.responsiveImage} />
          </div>
        ))
      : null

  return slides ? (
    <section className={styles.AboutGallery}>
      <Slider className={styles.slider} {...sliderSettings}>
        {slides}
      </Slider>
    </section>
  ) : null
}

export default AboutGallery
